import gsap from 'gsap';

const TitleInitial = (element) => {
  gsap.set([...element.querySelectorAll('.title__char')], { yPercent: 100 });
};

export default TitleInitial;
